import * as React from 'react';
import { Price, PriceContainer, StrikePrice } from './style';
import { string2money } from 'utils/string';

interface Props {
  price: number;
  isPriceList: boolean;
  regularPrice: number;
  isSelected: boolean;
  fontSize?: 'default' | 'small';
  minPrice?: number;
  maxPrice?: number;
  minRegularPrice?: number;
  maxRegularPrice?: number;
  fixedPrice?: number;
}

export default function PriceComponent(props: Props) {
  const {
    price,
    minPrice,
    maxPrice,
    minRegularPrice,
    maxRegularPrice,
    isPriceList,
    regularPrice,
    isSelected,
    fontSize = 'default',
    fixedPrice,
  } = props;

  const hasDynamicPrice =
    minPrice !== maxPrice || minRegularPrice !== maxRegularPrice;

  const getPriceText = React.useCallback(
    (min: number | string, max: number | string, price: number | string) => {
      if (hasDynamicPrice) {
        return `Rp. ${string2money(min)} - ${string2money(max)}`;
      }
      return `Rp. ${string2money(min || price)}`;
    },
    [hasDynamicPrice],
  );

  if (fixedPrice) {
    return (
      <PriceContainer>
        <Price fontSize={fontSize} isSelected={isSelected}>{`Rp. ${string2money(
          fixedPrice,
        )}`}</Price>
      </PriceContainer>
    );
  }

  return (
    <PriceContainer>
      <Price fontSize={fontSize} isSelected={isSelected}>
        {getPriceText(minPrice || 0, maxPrice || 0, price)}
      </Price>

      {isPriceList && (
        <StrikePrice fontSize={fontSize}>
          {getPriceText(
            parseFloat((minRegularPrice || 0).toString()),
            parseFloat((maxRegularPrice || 0).toString()),
            parseFloat((minRegularPrice || regularPrice).toString()),
          )}
        </StrikePrice>
      )}
    </PriceContainer>
  );
}
